export default {
    namespaced: true,
    state: {
        hello: 'こんにちは'
    },
    getters: {
        hello(state){
            return state.hello;
        }
    },
    mutations: {
        setHello(state, payload){
            state.hello = payload.hello;
        }
    },
    actions: {
        doUpdate({commit}, message){
            commit('setHello', {hello: message});
        }
    }
}
